import React, { useEffect } from "react";

import { Navigate, useParams, useNavigate } from "react-router-dom";

import { doc, getDoc } from "firebase/firestore";

import { db } from "../../firebase/config";

import { normalizeClassroomCode } from "../lib/classroomEngine";

import type { Task } from "../lib/taskEngine";



/**

 * Enlaces /task/CODE redirigen al detalle de la clase correspondiente.

 */

export const TaskViewPage: React.FC = () => {

  const { code } = useParams<{ code?: string }>();

  const navigate = useNavigate();



  useEffect(() => {

    if (!code) return;



    const taskCode = code.toUpperCase().trim();



    void (async () => {

      try {

        const snap = await getDoc(doc(db, "bordona_tasks", taskCode));

        if (snap.exists()) {

          const task = snap.data() as Task;

          if (task.classroomId) {

            navigate(

              `/clases/${normalizeClassroomCode(task.classroomId)}?task=${taskCode}`,

              { replace: true }

            );

            return;

          }

        }

        navigate("/clases", {

          replace: true,

          state: {

            taskError: "Entra a la clase correspondiente para abrir esta tarea.",

          },

        });

      } catch {

        navigate("/clases", { replace: true });

      }

    })();

  }, [code, navigate]);



  if (code) {

    return (

      <div className="min-h-screen flex items-center justify-center bg-[#100f0e]">

        <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-[#c4b5fd] animate-spin" />

      </div>

    );

  }



  return <Navigate to="/home" replace />;

};

